const CHECK_CIRCLE =
  'https://djhonz7dexnot.cloudfront.net/c36b4c90e1296b1bd10021b588841e0a84a1e785.webp'

const LANDING_BG_IMAGE =
  'https://djhonz7dexnot.cloudfront.net/10cfff68c18df5decede3e6bcf4c93e1c0920cdd.webp'

const BECAME_VIP_IMAGE =
  'https://djhonz7dexnot.cloudfront.net/c4afdbf60b11cc1c92cd3c4d13b5dcdccf84f71d.webp'

const VIDEO_COIN_GUIDE_MEDIA_ASSET = {
  IN: 'https://d2ps1cw166f1t3.cloudfront.net/14ec0e12111d791bbf012693397db21f7b10339a.mp4',
  US: 'https://d2ps1cw166f1t3.cloudfront.net/abcd0db8f695fed6e51eda897c19e18790b7e158.mp4',
  DEFAULT:
    'https://d2ps1cw166f1t3.cloudfront.net/f0e24370da3f723ccfb98fdf08ec3fb7c5a66577.mp4',
}

export {
  CHECK_CIRCLE,
  BECAME_VIP_IMAGE,
  LANDING_BG_IMAGE,
  VIDEO_COIN_GUIDE_MEDIA_ASSET,
}
